import React, { useState } from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { BiX } from "react-icons/bi";
import { toastContainer } from "../../../utils/toast";
import Select from "react-select";
import {
  DIFFICULTY_LEVELS,
  isTrivvyGeneratedFromCustomTemplates,
} from "../data";

export default function DuplicateTriviaPopup({
  open,
  onClose,
  item,
  afterDuplicateSuccess,
  isMessaging
}) {
  const [duplicateTrivvyName, setDuplicateTrivvyName] = useState(
    `Copy of ${item.name}`
  );

  const [difficultyLevel, setDifficultyLevel] = useState(0);

  const duplicateTrivvy = () => {
    axios
      .post(url.duplicateTrivia, {
        currentTriviaId: item._id,
        newDuplicateTrivvyName: duplicateTrivvyName,
        difficultyLevel,
        isMessaging: isMessaging || false
      })
      .then(({ data }) => {
        afterDuplicateSuccess(data.data);
        setTimeout(() => {
          onClose();
        }, 1000);
      })
      .catch((err) => {
        toastContainer("Error while duplicating trivvy", "error");
      });
  };
  return (
    <Modal isOpen={open} size="sm" centered>
      <ModalHeader
        className="trivia_modal_header_bg"
        close={
          <BiX
            className="cursor-pointer"
            color="gray"
            size={30}
            onClick={() => onClose()}
          />
        }
      >
        Duplicate trivvy
      </ModalHeader>

      <ModalBody className="p-3">
        <div className="mt-3">
          <p>
            Are you sure you want to duplicate <b>{item.name}</b>.
          </p>

          {item &&
          item.triviaType == 1 &&
          !isTrivvyGeneratedFromCustomTemplates(item) ? (
            <div className="my-3">
              <Label>Question Difficulty</Label>
              <Select
                options={[
                  { label: "No change", value: 0 },
                  ...DIFFICULTY_LEVELS,
                ]}
                value={difficultyLevel}
                onChange={(e) => {
                  if (e) {
                    setDifficultyLevel(e.value);
                  } else {
                    setDifficultyLevel(0);
                  }
                }}
                placeholder={"Select difficulty level"}
              />
            </div>
          ) : (
            ""
          )}

          <div className="my-3">
            <Label>Please set new duplicate trivvy name</Label>
            <Input
              value={duplicateTrivvyName}
              placeholder="Enter new duplicate trivvy name"
              onChange={(e) => {
                setDuplicateTrivvyName(e.target.value);
              }}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="trivia-action-button-secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={duplicateTrivvy} className="trivia-action-button-main">
          Continue
        </Button>
      </ModalFooter>
    </Modal>
  );
}
